import type Quill from 'quill';
import * as styles from './getContentRectForCurrentSelection.module.scss';
import { getRangeSaver } from '../../editor/RangeSaver';
import getRangeBoundaries from '../../editor/utils/getRangeBoundaries';

const COMMENT_THREAD_COMPACT_AVATAR_PADDING = parseInt(
  styles.commentThreadCompactAvatarPadding,
  10,
);

const getContentRectForCurrentSelection = (quill: Quill) => {
  const boundaries = getRangeBoundaries(quill, getRangeSaver(quill).getLast());

  if (!boundaries?.length) return null;

  const top = Math.min(...boundaries.map((rect) => rect.top));
  const bottom =
    Math.max(...boundaries.map((rect) => rect.top + rect.height)) +
    COMMENT_THREAD_COMPACT_AVATAR_PADDING;

  return DOMRect.fromRect({
    x: Math.min(...boundaries.map((rect) => rect.left)),
    y: top,
    height: bottom - top,
  });
};

export default getContentRectForCurrentSelection;
